<template>
  <div class="container">
    <loading :active="isLoading" :is-full-page="fullPage" :loader="loader" />
    <center style="height: 15rem">
       <div class="alert alert-success" role="alert">
      <h4 class="alert-heading">Payment Details</h4>
      <hr />
      <p class="mb-0"><b>Id: </b>{{paymentData.id}}</p>
      <p class="mb-0"><b>SP Order Id: </b>{{paymentData.sp_order_id}}</p>
      <p class="mb-0"> <b>Customer Order Id: </b>{{paymentData.customer_order_id}}</p>
      <p class="mb-0"><b>Invoice No: </b>{{paymentData.invoice_no}}</p>
      <p class="mb-0"><b>Amount: </b>{{paymentData.amount}}</p>
      <p class="mb-0"><b>Currency: </b>{{paymentData.currency}}</p>
      <p class="mb-0"><b>Customer Name: </b>{{paymentData.customer_name}}</p>
      <p class="mb-0"><b>Customer Address: </b>{{paymentData.customer_address}}</p>
      <p class="mb-0"><b>Customer City: </b>{{paymentData.customer_city}}</p>
      <p class="mb-0"><b>SP Message: </b>{{paymentData.sp_massage}}</p>
      <p class="mb-0"><b>Transaction Status: </b>{{paymentData.transaction_status}}</p>
      <p class="mb-0"><b>Completed: </b>{{paymentData.completed}}</p>
      <p class="mb-0"><b>Deleted: </b>{{paymentData.deleted}}</p>
      <p class="mb-0"><b>Created At: </b>{{paymentData.created_at}}</p>
      <p class="mb-0"><b>Updated At: </b>{{paymentData.updated_at}}</p>
      <p class="mb-0"><b>User Id: </b>{{paymentData.user_id}}</p>
    </div>
    </center>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
export default {
  name: "PaymentDetails",
  components: { Loading },
  data() {
    return {
      vp: this.$route.params.vp,
      paymentData: [],
      //for loader
      isLoading: false,
      fullPage: true,
      loader: "bars"
    };
  },
  methods: {
    async getData() {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.get(
          this.$baseUrl +
            this.$api +
            this.$version1 +
            "/payment/getbyId?orderId=" +
            this.vp,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          }
        );
        this.isLoading = false;
        if (res.status == 200) {
          this.paymentData = res.data[0];
          console.log(this.paymentData);
        } else {
          this.$vToastify.error("Could not fetch data!");
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    }
  },
  mounted() {
    // use this for get
    this.getData();
  }
};
</script>